import { Typography } from 'seagull';
import { utils } from "../../../../utils";
import { timeModel } from "../../../../models";
import { LineItemPendingApprovalReason } from "../../../../types/api.model";
import styles from "./ScheduledInvoice.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const columnDefs = [{
  width: 330,
  value: 'Service Name'
}, {
  width: [53, 90],
  hAlign: 'end',
  value: 'Quantity'
}, {
  width: [90, 120],
  hAlign: 'end',
  value: 'Rate'
}, {
  width: [70, 90],
  hAlign: 'end',
  value: 'Discount'
}, {
  width: [80, 104],
  hAlign: 'end',
  value: 'Total'
}, {
  width: 130,
  value: 'Status'
}, {
  width: 96,
  value: ''
}];
export const HeaderDateIndicator = _ref => {
  let {
    label,
    date,
    testid
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.headerDateIndicator,
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      weight: "normal",
      children: label
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      "data-testid": testid,
      children: timeModel.formatDateLong(date)
    })]
  });
};
export const makeTestId = charge => "scheduled-invoice-row-".concat(charge.id);
export function displayLineItemRate(rate) {
  return !rate || rate.amount.isZero() ? '' : rate.unit ? "".concat(utils.formatDollarAmount(rate.amount), "/").concat(rate.unit) : utils.formatDollarAmount(rate.amount);
}
export function getClientStatusTooltip(pendingApprovalReason) {
  switch (pendingApprovalReason) {
    case LineItemPendingApprovalReason.AdHocCharge:
      return 'Your ongoing agreement does not cover this charge';
    case LineItemPendingApprovalReason.ServiceAmendment:
      return 'There is an unapproved amendment to this service';
    case LineItemPendingApprovalReason.VariableExceedsCap:
      return 'The amount charged exceeds the preapproved quantity';
    case LineItemPendingApprovalReason.VariableZeroCap:
      return 'A preapproved quantity was not set for this service';
    case LineItemPendingApprovalReason.RangeExceedsMaxPrice:
      return 'The amount charged exceeds the preapproved rate';
    case LineItemPendingApprovalReason.VariableCumulative:
      return 'The amount charged exceeds the preapproved quantity';
    case LineItemPendingApprovalReason.NonVariableCumulative:
    case LineItemPendingApprovalReason.OverlappingPeriod:
      return 'A charge for this service was issued more than once during this period';
  }
}
export function getVendorStatusTooltip(pendingApprovalReason) {
  switch (pendingApprovalReason) {
    case LineItemPendingApprovalReason.AdHocCharge:
      return 'Out-of-agreement charges require client approval';
    case LineItemPendingApprovalReason.ServiceAmendment:
      return 'Amendment is pending client approval';
    case LineItemPendingApprovalReason.VariableExceedsCap:
      return 'Exceeding the preapproved quantity requires client approval';
    case LineItemPendingApprovalReason.VariableZeroCap:
      return 'A preapproved quantity was not set for this service';
    case LineItemPendingApprovalReason.RangeExceedsMaxPrice:
      return 'Exceeding the preapproved rate requires client approval';
    case LineItemPendingApprovalReason.VariableCumulative:
      return 'Exceeding the preapproved quantity requires client approval';
    case LineItemPendingApprovalReason.NonVariableCumulative:
    case LineItemPendingApprovalReason.OverlappingPeriod:
      return 'Billing this service more than once per period requires client approval';
  }
}